// extracted by mini-css-extract-plugin
module.exports = {"tenantLogo":"_3aMaL___NotableTenants-module__tenantLogo","title":"_207Ul___NotableTenants-module__title","container":"_1bAgr___NotableTenants-module__container"};